import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiJsonViewModule } from '@netfoundry-ui/ui/json-view';
import { ReactiveFormsModule } from '@angular/forms';
import { PrecheckDetailsComponent } from './precheck-details/precheck-details.component';
import { UiTableModule } from '@netfoundry-ui/ui/table';

@NgModule({
    imports: [CommonModule, UiJsonViewModule, ReactiveFormsModule, UiTableModule],
    declarations: [PrecheckDetailsComponent],
    exports: [PrecheckDetailsComponent],
})
export class FeaturePrecheckDetailsModule {}
